import React, {useEffect, useState, useContext} from 'react';
import PropTypes from 'prop-types';
import {withRouter} from 'react-router-dom';
import {withStyles} from '@material-ui/core/styles';
import {IconButton, Paper, Typography, Grid} from '@material-ui/core';
import {Edit as EditIcon, DeleteForever as DeleteForeverIcon} from '@material-ui/icons';
import {SecondaryNavigation} from 'components/Navigation';
import {levelMap} from 'utils/common';
import {fetchQuiz, deleteQuiz} from 'api/quiz';
import QuestionList from './QuestionList';
import {DeletionConfirmBox, Modal} from '../common';
import QuizForm from './QuizForm';

const useDetailStyles = withStyles({
  information: {
    padding: 20,
  },
});

const QuizDetail = useDetailStyles(
  ({
    match: {
      params: {quizId},
    },
    history,
    classes,
  }) => {
    const [quiz, setQuiz] = useState({});
    const [quizModalOpen, setQuizModalOpen] = useState(false);

    useEffect(() => {
      fetchQuiz(quizId).then(({record}) => setQuiz(record));
    }, []);

    const showQuizModal = () => setQuizModalOpen(true);

    const closeQuizModal = () => setQuizModalOpen(false);

    return (
      <div>
        <SecondaryNavigation key="secondary-nav" hasBack />
        <div key="container" className="container content-box">
          <Paper className={classes.information}>
            <Modal
              title="Edit Quiz"
              onClose={closeQuizModal}
              open={quizModalOpen}
              renderContent={() => (
                <QuizForm
                  initialValues={quiz}
                  onCancel={closeQuizModal}
                  onSubmitSuccess={({record}) => {
                    setQuiz(record);
                    closeQuizModal();
                  }}
                />
              )}
            />
            <h3 className="section-header">
              <div className="section-title">Quiz Information</div>
              <div>
                <DeletionConfirmBox
                  itemName="quiz"
                  deleteAction={() => deleteQuiz(quizId).then(() => history.push('/quiz'))}
                  DeleteButton={(props) => (
                    <IconButton variant="contained" color="primary" {...props}>
                      <DeleteForeverIcon />
                    </IconButton>
                  )}
                />
                <IconButton variant="contained" color="primary" onClick={showQuizModal}>
                  <EditIcon />
                </IconButton>
              </div>
            </h3>
            <div className="table-block">
              {[
                {label: 'Title', value: quiz.title},
                {label: 'Level', value: levelMap[quiz.level]},
                {label: 'Reading Nights', value: quiz.readingNights},
              ].map(({label, value}, index) => (
                <div className="table-row" key={index}>
                  <Grid container>
                    <Grid item>
                      <div className="table-cell">{label}</div>
                    </Grid>
                    <Grid item>
                      <div className="table-cell" style={{width: 500}}>
                        <Typography variant="h6" noWrap={true}>
                          {value}
                        </Typography>
                      </div>
                    </Grid>
                  </Grid>
                </div>
              ))}
            </div>
          </Paper>
        </div>
        <QuestionList quizId={quizId} />
      </div>
    );
  },
);

export default withRouter(QuizDetail);
